/**
 * How tall the figure list and the element column may grow before they scroll inside
 * themselves: a little over half the screen, so both end above the walk-through at
 * 1440×900 and at 2560×1261.
 */
export const DEFINE_COLUMN_BOUND = "lg:max-h-[62vh]";
